import { FC, useMemo, useState } from "react";
import {
  Accordion,
  Checkbox,
  CloseButton,
  Radio,
  ScrollArea,
  TextInput,
} from "@mantine/core";

interface Data {
  label: string;
  value: string;
}

export type FilterSectionProps<TType = "checkbox" | "radio"> =
  TType extends "checkbox"
    ? {
        title: string;
        sectionKey: string;
        type: TType;
        data: Data[];
        value: string[] | undefined;
        onChange: (value: string[]) => void;
        height?: number;
        filterable?: boolean;
      }
    : {
        title: string;
        sectionKey: string;
        type: TType;
        data: Data[];
        value: string | undefined;
        onChange: (value: string) => void;
        height?: number;
        filterable?: boolean;
      };

//eslint-disable-next-line
export const FilterSection: FC<FilterSectionProps> = ({
  title,
  sectionKey,
  type,
  data,
  value,
  onChange,
  height,
  filterable = false,
}) => {
  const [query, setQuery] = useState("");
  const filteredData = useMemo(() => {
    return data.filter((item) =>
      item.label.toLowerCase().includes(query.toLowerCase())
    );
  }, [query, data]);
  return (
    <Accordion.Item value={sectionKey}>
      <Accordion.Control>{title}</Accordion.Control>
      <Accordion.Panel>
        {filterable && (
          <TextInput
            placeholder={`Filter by ${title.toLowerCase()}`}
            value={query}
            onChange={(value) => setQuery(value.currentTarget.value)}
            rightSection={
              <CloseButton color="gray" onClick={() => setQuery("")} />
            }
          />
        )}
        <ScrollArea style={{ height: height || 150 }} type="auto">
          {type === "checkbox" && (
            <Checkbox.Group
              value={value as string[]}
              onChange={onChange}
              orientation="vertical"
            >
              {filteredData.map((d) => (
                <Checkbox
                  key={d.value}
                  value={d.value}
                  label={d.label}
                  color="violet"
                />
              ))}
            </Checkbox.Group>
          )}

          {type === "radio" && (
            <Radio.Group
              value={value as string}
              onChange={onChange}
              orientation="vertical"
            >
              {filteredData.map((d) => (
                <Radio
                  key={d.value}
                  value={d.value}
                  label={d.label}
                  color="violet"
                />
              ))}
            </Radio.Group>
          )}
        </ScrollArea>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
